import { FormattedMessage } from 'react-intl';
import CarouselDisplayTrigger from '@alltrails/amplitude/enums/CarouselDisplayTrigger';
import logSignUpScreenContinueButtonTapped from '@alltrails/amplitude/events/logSignUpScreenContinueButtonTapped';
import Button from '@alltrails/denali/components/Button';
import useDeeplink from '@alltrails/install-prompt/hooks/useDeeplink';
import type DeeplinkData from '@alltrails/types/DeeplinkData';

type Props = {
  deeplinkData?: DeeplinkData;
  displayTrigger: CarouselDisplayTrigger;
  flatColors?: boolean;
};

export default function ContinueInAppButton({ deeplinkData, displayTrigger, flatColors = false }: Props) {
  const getDeeplink = useDeeplink({ deeplinkData, promptType: 'auth-wall', isOpen: true, displayTrigger });

  return (
    <Button
      linkInfo={{ href: getDeeplink() }}
      text={
        <>
          <FormattedMessage defaultMessage="Continue in app" />
        </>
      }
      onClick={() => {
        logSignUpScreenContinueButtonTapped({ signup_screen_continue_button_type: 'continue in app' });
      }}
      testId="continue-in-app"
      variant={flatColors ? 'primary' : 'accent'}
      width="full"
    />
  );
}
